import type { EuropeanIntervention } from "../engine/types";

interface Props {
  interventions: EuropeanIntervention[];
  currentTurn: number;
}

const PROCEDURE_LABELS: Record<string, string> = {
  eu_edp_deficit: "Procédure de déficit excessif",
  eu_surveillance_dette: "Surveillance budgétaire renforcée",
  eu_mes_tutelle: "MES — aide conditionnelle",
  eu_article_7: "Article 7 TUE",
  eu_fonds_geles: "Conditionnalité État de droit — fonds gelés",
};

const PROCEDURE_GRAVITY: Record<string, "minor" | "major" | "critical"> = {
  eu_edp_deficit: "minor",
  eu_surveillance_dette: "minor",
  eu_mes_tutelle: "major",
  eu_article_7: "critical",
  eu_fonds_geles: "critical",
};

function procedureLabel(id: string): string {
  return PROCEDURE_LABELS[id] ?? id;
}

function procedureGravity(id: string): "minor" | "major" | "critical" {
  return PROCEDURE_GRAVITY[id] ?? "minor";
}

export function EuropeanProceduresDrawer({
  interventions,
  currentTurn,
}: Props) {
  if (!interventions || interventions.length === 0) return null;

  const sorted = [...interventions].sort(
    (a, b) => b.triggered_at_turn - a.triggered_at_turn,
  );

  return (
    <details className="drawer drawer-appear drawer-eu">
      <summary>
        🇪🇺 Bruxelles{" "}
        <span className="drawer-count">· {interventions.length}</span>
      </summary>
      <div className="drawer-body">
        {sorted.map((iv, i) => {
          const gravity = procedureGravity(iv.id);
          const age = currentTurn - iv.triggered_at_turn;
          return (
            <div
              key={`${iv.id}-${i}`}
              className="eu-procedure"
              data-gravity={gravity}
            >
              <div className="eu-procedure-head">
                <span className="eu-procedure-label">
                  {procedureLabel(iv.id)}
                </span>
                <span className="eu-procedure-age">
                  {age === 0 ? "ce tour" : `T-${age}`}
                </span>
              </div>
              <div className="eu-procedure-source">{iv.source}</div>
              <div className="eu-procedure-text">{iv.headline_text}</div>
            </div>
          );
        })}
        <div className="drawer-subtitle">À propos</div>
        <p
          style={{
            fontSize: "var(--type-caption)",
            color: "var(--color-grey-1)",
            fontStyle: "italic",
          }}
        >
          L'Union européenne agit comme cinquième personnage du jeu. Quand
          certains seuils sont franchis, la Commission, le Conseil ou le
          Parlement interviennent automatiquement. Surveillez la jauge 🇪🇺 dans
          le bandeau.
        </p>
      </div>
    </details>
  );
}
